import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersBenefitsComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_offers-benefits';

    public async onReloadComponentEvent(): Promise<void> {
        const variationId = this.getRootElement().dataset.variationId || '';
        this.renderBenefitComponent(variationId);
    }

    private renderBenefitComponent(variationId: string): void {
        const targetElements = this.getChildElements('.js_of_offers-benefits__benefit-target');
        const isSoldOut = this.getRootElement().dataset.isSoldOut === 'true';
        const productId = this.getRootElement().dataset.productId || '';

        if (isSoldOut) {
            return;
        }

        targetElements.forEach(targetElement => {
            targetElement.innerHTML = `<ft9-detailview-v1 team="ft5" feature="vasDetailview" variation-id="${variationId}" product-id="${productId}" add-padding></ft9-detailview-v1>`;
        });
    }
}
